import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges, TemplateRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { PageType } from 'src/app/services/pageTypes';
import { ProfilePhoto } from 'src/app/services/profilePhoto';
import { UtilService } from 'src/app/services/util.service';
import { CommonModule } from '@angular/common';
import { TagInputModule } from 'ngx-chips';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import Swal from 'sweetalert2';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-invite-collegue',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TagInputModule,
NG_ICON_DIRECTIVES,
  ],
  templateUrl: './invite-collegue.component.html',
  styleUrls: ['./invite-collegue.component.scss']
})
export class InviteCollegueComponent implements OnInit, OnChanges {

  modalRef: BsModalRef;
  connectionRequest: UntypedFormGroup;
  landingPageUserDatails: any;
  inviteDisable: boolean = false;
  splitPattern = new RegExp('[\,\;\:]');
  public errorMessages = {
    'emailValid': 'Please enter valid email id'
  }

  headerTitle: string = 'Invite Colleagues';
  validators = [this.emailValid];
  userId: string;
  userDetailsLanding: any;
  userName: any;
  img: any = {};
  @Input() maxMin: any = {};
  @Input() page: string;
  viewType: string = "MIN";
  showflag: boolean = false;
  @Input() inputData: string;
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  userType:any;
  gigsumoNo: any;
  constructor(
    private modalService: BsModalService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private a_route: ActivatedRoute,
    private profilePhoto: ProfilePhoto,
    private util: UtilService,
    private pageType: PageType,
    private API: ApiService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any
  ) {
    this.userType =localStorage.getItem('userType');

    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
      }
      if (this.widgetData.page) {
        this.page = this.widgetData.page;
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
    }
  }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Invite Colleagues';
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "InviteCollegueComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {

    this.userType =localStorage.getItem('userType');
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.userType =localStorage.getItem('userType');
    this.a_route.queryParams.subscribe((res) => {
      if (res.master && res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })


    // this.showflag=false;
    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }
    this.connectionRequest = this.fb.group({
      email: [null, Validators.required],
      msg: [null]
    });
    this.userId = localStorage.getItem('userId');
    this.API.query('user/' + this.userId).subscribe(res => {
      this.util.stopLoader()
      this.showflag = true;
      this.gigsumoNo = res.gigsumoNo;

      this.userDetailsLanding = res;
      this.userName = res.username;
      localStorage.setItem('userName', this.userName);
    }, err => {
      this.util.stopLoader();
    });

    this.landingPageUser();
  }

  routeToReferal() {
    let params = {
      userId: localStorage.getItem('userId'),
      plan: localStorage.getItem('MemberShipType'),
      businessName: localStorage.getItem('currentOrganization'),
      businessEmail: localStorage.getItem('userName'),
      bid: this.gigsumoNo,
    };
    this.router.navigate(['user-management/referral'] , {queryParams : params});
    setTimeout(() => {
      var data: any = {}
      data.pages = 'referrals'
      this.pageType.setPageName(data)
    }, 2000);
  }

  openModal(template: TemplateRef<any>) {
    this.connectionRequest.reset();
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static'
    });
  }

  closeInviteModal() {
    this.modalRef.hide();
    this.connectionRequest.reset();
  }

  // emailValid(control: AbstractControl) {
  // //   //// console.log(control);
  //   if (Validators.email(new FormControl(control.value))) {
  //   //  //// console.log(true);
  //     return {
  //           'emailValid': true
  //       };
  //   }
  // }

  emailValid(control: AbstractControl) {
    //   console.log(control);
    var pattern: string = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+){1,2}$";
    //if (Validators.email(new FormControl(control.value))) {
    const control1 = new UntypedFormControl(control.value, Validators.pattern(pattern));
    if (control1.errors != null) {
      //  console.log(true);
      return {
        'emailValid': true
      };
    }
  }




  invitation() {

    // i changed sinle line

    const input = {
      userId: this.landingPageUserDatails.userId,
      firstName: this.landingPageUserDatails.firstName,
      lastName: this.landingPageUserDatails.lastName,
      inviteEmailList: this.connectionRequest.value.email,
      message: this.connectionRequest.value.msg

    };
    /// this.landingPageUserDatails.inviteeEmail = this.InvitationForm;
    this.inviteDisable = true;
    this.util.startLoader();
    this.API.create('home/inviteeUser', input).subscribe(res => {
      this.util.stopLoader()
      if (res) {
        this.closeInviteModal();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Invite sent successfully',
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          //  //// console.log("login redirect")
          //  //// console.log("login redirect" +result.isConfirmed)
          if (result.isConfirmed) {
          }
        });

      } else {

      }
      this.inviteDisable = false;
    }, err => {
      this.util.stopLoader();
    });
  }

  landingPageUser() {
    this.util.startLoader()
    this.API.queryPassval('home/' + this.userId, this.userDetailsLanding).subscribe(res => {
      this.util.stopLoader()
      this.landingPageUserDatails = res;
      this.img = {}
      // if (res.photo != undefined) {
      //   this.profilePhoto.setPhoto(res.photo)
      // }
      // if (res.photo === null) {
      //   this.img = {}
      //   this.profilePhoto.setPhoto(null)
      // }
    }, err => {
      this.util.stopLoader();
    });

  }




}
